// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J-cR-","title":"styles_title__1ZOhQ"};